/*global _ */
import InputMixin from '../../../../mixins/form/input'
import DesignerMixin from './designer'
import contextProp from '../../../../props/context'
const mixins = [InputMixin, DesignerMixin]

export default {
  name: 're-text',
  mixins,
  props: {
    ...contextProp,
    value: {
      default: null
    },
  },
  data() {
    return {
    }
  },
  computed: {
  },
  methods: {

  }
}
